import type { UsageSummary } from "./usage.ts";

type Day = UsageSummary["byDay"][number];

/**
 * Qué se pinta: el coste si algún día lo tiene, y si no, los tokens.
 *
 * Una sola magnitud y un solo eje, nunca los dos a la vez: tokens y dólares no
 * comparten escala. Si el coste es desconocido para todo el rango, pintarlo a
 * cero diría "gratis", así que se pintan los tokens y el título lo dice.
 */
export const dailyMeasure = (days: readonly Day[]): "cost" | "tokens" =>
  days.some((day) => day.costUsd !== null) ? "cost" : "tokens";
